// extracted by mini-css-extract-plugin
module.exports = {"tuangou":"tuangou-1OYjeUpG","tuangou_b":"tuangou_b-1JuoPKNA","tit":"tit-1jqchMCv","longpic":"longpic-3LRaxzKf","tuangou_page":"tuangou_page-2nLvCwi4"};